// extracted by css-extract-rspack-plugin
export default {"PreviewContainer":"VGCzY"};